import { render, staticRenderFns } from "./aiartList.vue?vue&type=template&id=76a6512c&"
import script from "./aiartList.vue?vue&type=script&lang=js&"
export * from "./aiartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports